import { PdfGen, PdfUnit, PdfSize, PdfRect } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { GCalc } from '../../pdf/gcalc';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/label';

/**
 * Kolicky__1 (Pegs 1) - 3×3 sub-grid matching
 *
 * Layout: 2 portrait pages, 2×3 grid of cells.
 * Each cell has a 3×3 sub-grid: center shows left (question) label,
 * surrounding 8 cells show shuffled answer labels (7 random + correct one).
 *
 * Migrated from C# EduFrame.Img10.Generators.Kolicky__1
 */
export class Kolicky__1 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const { origin, size } = calcOrigin(2, 3, margin, PdfSize.A4);

    const pageCount = 2;

    for (let page = 0; page < pageCount; page++) {
      const pg = pdf.addPage();

      for (let y = 0; y < 3; y++) {
        for (let x = 0; x < 2; x++) {
          const index1 = page * 2 * 3 + y * 2 + x;
          if (index1 >= opts.list.length) continue;

          const rect1 = new PdfRect(
            origin.x + x * size.width,
            origin.y + y * size.height,
            size.width,
            size.height
          );
          const rect2 = GCalc.centerRect(rect1);

          // Adjust font for answer labels
          const answerTexts = opts.list.map((t) => t.right.getText() ?? '');
          const font = pg.adjustFont(rect2.width / 3, answerTexts, GUtil.baseFont);

          // Pick 7 random other answers + the correct one, shuffled
          const others = opts.list
            .filter((_, i) => i !== index1)
            .sort(() => opts.data.random.next(0, 2) - 1)
            .slice(0, 7);
          const labels = [...others, opts.list[index1]].sort(() => opts.data.random.next(0, 2) - 1);

          for (let yy = 0; yy < 3; yy++) {
            for (let xx = 0; xx < 3; xx++) {
              let index2 = yy * 3 + xx;
              if (index2 >= 4) index2--;
              const rect = new PdfRect(
                rect2.x + (xx * rect2.width) / 3,
                rect2.y + (yy * rect2.height) / 3,
                rect2.width / 3,
                rect2.height / 3
              );

              if (xx === 1 && yy === 1) {
                pg.drawLabel(opts.list[index1].left, { rect });
              } else {
                pg.drawLabel(labels[index2].right, { rect, font });
              }

              pg.drawRectangle(GUtil.basePen, null, rect);
            }
          }
        }
      }
    }
  }
}
